import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  TranslateLoader,
  licenseGuard,
  loginGuard,
  publicLicenseGuard,
  publicSharedBuildingLoginGuard,
  redirectToGoToApp,
  userGuard
} from '@cfp/core';

const routes: Routes = [
  {
    path: '',
    data: { module: 'roadmap' },
    resolve: [TranslateLoader],
    children: [
      {
        path: 'public/buildings/:publicSharedId',
        loadComponent: () => import('./pages/public-roadmap-building-page').then((m) => m.PublicRoadmapBuildingPage),
        data: { license: 'roadmap' },
        canActivate: [publicLicenseGuard, publicSharedBuildingLoginGuard]
      },
      {
        path: ':portfolioId',
        loadComponent: () => import('@cfp/shared/portfolio/layout').then((m) => m.PortfolioLayoutProvider),
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/roadmap-portfolio-page').then((m) => m.RoadmapPortfolioPage),
            data: { license: 'roadmap', modulePath: 'roadmap', appendPageTitle: 'header.roadmap-module' },
            canActivate: [loginGuard, userGuard, licenseGuard]
          }
        ]
      },
      {
        path: ':portfolioId/buildings/:buildingId',
        loadComponent: () => import('@cfp/shared/building/layout').then((m) => m.BuildingLayoutProvider),
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/roadmap-building-page').then((m) => m.RoadmapBuildingPage),
            data: { license: 'roadmap', modulePath: 'roadmap', appendPageTitle: 'header.roadmap-module' },
            canActivate: [loginGuard, userGuard, licenseGuard]
          }
        ]
      },
      {
        path: '**',
        redirectTo: redirectToGoToApp
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoadmapRoutingModule {}
